import { QUERY_CONDITION, QUERY_OPERATION, QUERY_TYPE } from '@/utils/constants';
import QueryFactory, { QueryItem } from '@/utils/helpers/filters/base';
import { formatDateToUTC, getEndOfDay } from '@/utils/helpers/globalHelper';

export interface IQueryFilterParams {
  keyword?: string;
  countryId?: string;
  formId?: string;
  categoryId?: string;
  patternId?: string;
  updatedDateFrom?: string;
  updatedDateTo?: string;
}

export class TemplateListQueryFactory extends QueryFactory {
  getById(value: string, field: string, operation = QUERY_OPERATION.EQUAL) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    const idQuery = new QueryItem().modules.guidWith(value, { fieldTitle: field, operation });
    newQuerySection.childrens?.push(idQuery);
    this.append(newQuerySection);
    return this;
  }
  getByIds(value: string[], field: string) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    const idQuery = new QueryItem(field, QUERY_TYPE.GUID, value?.join(';') ?? '', QUERY_OPERATION.ANY, QUERY_CONDITION.EMPTY);
    newQuerySection.childrens?.push(idQuery);
    this.append(newQuerySection);
    return this;
  }
  updatedDateFrom(date: string) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    newQuerySection?.childrens?.push(new QueryItem().modules.fromDate(date, { fieldTitle: 'updatedDate' }));
    this.append(newQuerySection);
    return this;
  }

  updatedDateTo(date: string) {
    const newQuerySection = this.initNewQuery(this.data?.length ? QUERY_CONDITION.AND : QUERY_CONDITION.EMPTY);
    newQuerySection?.childrens?.push(new QueryItem().modules.toDate(date, { fieldTitle: 'updatedDate' }));
    this.append(newQuerySection);
    return this;
  }
}

export const generateFilter = (params?: IQueryFilterParams): string => {
  const filterFactory = new TemplateListQueryFactory();
  if (params?.keyword) {
    filterFactory.searchingBy(['nameSearch.ToLower()', 'updatedNameSearch.ToLower()', 'countryNameSearch.ToLower()'], params.keyword.toLowerCase());
  }
  if (params?.countryId) {
    filterFactory.getById(params.countryId, 'countryId');
  }
  if (params?.formId) {
    filterFactory.getById(params.formId, 'formId');
  }
  if (params?.categoryId) {
    filterFactory.getById(params.categoryId, 'categoryId', QUERY_OPERATION.ANY);
  }
  if (params?.patternId) {
    filterFactory.getById(params.patternId, 'patternId');
  }
  if (params?.updatedDateFrom) {
    filterFactory.updatedDateFrom(formatDateToUTC(params?.updatedDateFrom));
  }
  if (params?.updatedDateTo) {
    filterFactory.updatedDateTo(formatDateToUTC(getEndOfDay(params.updatedDateTo)));
  }
  return filterFactory.sanitize().stringifyData();
};
